import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { Injectable } from "@angular/core";
import { FormGroup, FormArray } from "@angular/forms";
import swal from "sweetalert2";
import { PageEnum } from "./shared/models/page-enum.model";
import Swal from "sweetalert2";

/**
 * Interface que deve ser implementada pelos componentes que necessitam passar pela verificação de troca de rota.
 */
export interface IPendingChangesCheckComponent {
  mainForm: FormGroup;
  mainFormArray?: FormArray;
  mainActionStatus: boolean;
}

/**
 * Guard que valida o componente com a interface implementada, se o form principal do componente implementado estiver com status [dirty] questiona o usuário se ele realmente quer mudar a rota.
 */
@Injectable()
export class PendingChangesGuard
  implements CanDeactivate<IPendingChangesCheckComponent>
{
  canDeactivate(
    component: IPendingChangesCheckComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): boolean | Promise<boolean> {
    if (
      this.validateComponentPageMode(component) &&
      !this.validateMainActionStatus(component) &&
      (this.validateComponent(component) ||
        this.validateComponentOptionals(component)) &&
      !nextState.url.includes("/unauthorized/401")
    ) {
      return this.resolveDialog();
    } else {
      return true;
    }
  }

  /**
   * Valida o status do form principal.
   * @param component Interface do componente a ser validado.
   */
  private validateComponent(component: IPendingChangesCheckComponent): boolean {
    return component && component.mainForm && component.mainForm.dirty;
  }

  /**
   * Valida o status do form principal e do form opcional.
   * @param component Interface do componente a ser validado.
   */
  private validateComponentOptionals(
    component: IPendingChangesCheckComponent
  ): boolean {
    return (
      this.validateComponent(component) &&
      component.mainFormArray &&
      component.mainFormArray.dirty
    );
  }

  /**
   * Valida o pageMode do componente.
   * @param component Interface do componente a ser validado.
   */
  private validateComponentPageMode(
    component: IPendingChangesCheckComponent
  ): boolean {
    return (
      (component as any).pageMode === PageEnum.Editando ||
      (component as any).pageMode === PageEnum.Incluindo
    );
  }

  /**
   * Valida o mainActionStatus se a ação principal do componente já foi executada.
   * @param component Interface do componente a ser validado.
   */
  private validateMainActionStatus(
    component: IPendingChangesCheckComponent
  ): boolean {
    return component.mainActionStatus;
  }

  /**
   * Cria e resolve a mensagem de informação para o usuário.
   */
  private resolveDialog(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      Swal.fire({
        title: "Tem certeza?",
        text: "Se sair agora irá perder todos dados.",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, desejo sair!",
        cancelButtonText: "Não, continuar modificando!",
        // confirmButtonClass: 'btn btn-success',
        // cancelButtonClass: 'btn btn-danger',
      }).then(
        (success) => {
          resolve(true);
        },
        function (error) {
          resolve(false);
        }
      );
    });
  }
}
